import React from 'react';

import { experiments } from './experiments';
import { clearCookie, getCookie, setCookie } from '../utils/cookie';

export default function coordinateExperiments() {
  const experimentName = getCookie('experiment', document);
  const hasCurrentExperiment =
    experimentName && experiments.some(exp => exp.name === experimentName);

  if (hasCurrentExperiment) {
    return;
  }

  const secureCookie = process.env.NODE_ENV === 'production';

  clearCookie('experiment', document, secureCookie);
  clearCookie('variant', document, secureCookie);

  const experiment = chooseRandomElement(experiments);

  if (experiment) {
    setCookie(
      {
        name: 'experiment',
        value: experiment.name,
        expirationInMillis: 7 * 24 * 60 * 60 * 1000,
        secure: secureCookie,
      },
      document
    );

    const variant = chooseRandomElement(experiment.variants);

    if (variant) {
      setCookie(
        {
          name: 'variant',
          value: variant,
          expirationInMillis: 7 * 24 * 60 * 60 * 1000,
          secure: secureCookie,
        },
        document
      );
    }
  }
}

export function getExperimentDetails() {
  const experimentName = getCookie('experiment', document);
  const variantName = getCookie('variant', document);

  return { experimentName, variantName };
}

export function Experiment({ children, name }) {
  let chosenVariant;
  const { experimentName, variantName } = getExperimentDetails();

  if (experimentName === name) {
    chosenVariant = children.find(
      variant => variant.props.name === variantName
    );
  }

  chosenVariant =
    chosenVariant ||
    children.find(variant => variant.props.defaultOption) ||
    children[0];

  return chosenVariant ? chosenVariant : null;
}

export function Variant({ children, defaultOption = false, name = '' }) {
  return <div>{children}</div>;
}

const chooseRandomElement = arr => {
  return arr[Math.floor(Math.random() * arr.length)];
};
